import React from "react";
export const SubmitErrors = (props) => {
    return props.errors.length > 0 ? (React.createElement("div", { className: "alert error" },
        "Formul\u00E1\u0159 obsahuje n\u00E1sleduj\u00EDc\u00ED chyby:",
        React.createElement("ul", null, props.errors.map((err) => {
            return React.createElement("li", null, props.dictionary[err]);
        })))) : null;
};
